<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="pull-left">
        <h5>
          Timeline
        </h5>
      </div>

      <div class="pull-right">
        <div class="btn-group" style="margin-top: 4px">
          <button type="button" class="btn btn-black btn-sm dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-plus"></i> Add <span class="caret"></span>
          </button>

          <ul class="dropdown-menu">
            <li>
              <a href="#create-comment-modal" data-toggle="modal">
                <i class="fa fa-comment"></i> Create Comment
              </a>
            </li>

            <li>
              <a href="#create-reminder-modal" data-toggle="modal">
                <i class="fa fa-bell"></i> Create Reminder
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="clearfix"></div>
    </div>

    <loading-spinner v-if="loading"></loading-spinner>

    <ul v-else class="list-group">
      <li class="list-group-item" v-for="logLine in slicedLogLines">
        <div class="pull-left">
          <log-line-headline :log-line="logLine"></log-line-headline>
        </div>

        <div class="pull-right">
          <log-line-actions
              :log-line="logLine"
              @edit="edit(logLine)"
              @resolve="resolve(logLine)"
              @postpone="postpone(logLine)"
          ></log-line-actions>
        </div>

        <div class="clearfix"></div>

        <log-line-content :log-line="logLine"></log-line-content>

        <br>

        <i>
          <log-line-footer :log-line="logLine"></log-line-footer>
        </i>
      </li>

      <li class="list-group-item">
        <router-link :to="person.data.id +'/timeline'">
          Show more...
        </router-link>
      </li>
    </ul>

    <CreateCommentModal :subject="person" @created="load"/>

    <CreateReminderModal :subject="person" @created="load"/>

    <PostponeReminderModal :reminder="editing" @postponed="load"/>

    <UpdateReminderModal :reminder="editing" @updated="load"/>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import CreateCommentModal from '@/pages/Shared/Modals/CreateComment'
import CreateReminderModal from '@/pages/Shared/Modals/CreateReminder'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import LogLineContent from '@/components/LogLine/LogLineContent'
import LogLineFooter from '@/components/LogLine/LogLineFooter'
import LogLineHeadline from '@/components/LogLine/LogLineHeadline'
import LogLineUser from '@/components/LogLine/LogLineUser'
import LogLineActions from '@/components/LogLine/LogLineActions'
import UpdateReminderModal from '@/pages/Shared/Modals/UpdateReminder'
import PostponeReminderModal from "../../../../../../../components/Modals/Reminders/PostponeReminderModal.vue";

export default {
  components: {
    PostponeReminderModal,
    LogLineActions,
    CreateCommentModal,
    CreateReminderModal,
    LoadingSpinner,
    LogLineContent,
    LogLineFooter,
    LogLineHeadline,
    LogLineUser,
    UpdateReminderModal
  },

  props: ['person'],

  data() {
    return {
      loading: true,
      logLines: null,
      editing: null
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    slicedLogLines() {
      return this.logLines.data.slice(0, 5)
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v1/log-lines', {
        'owner[id]': this.person.data.id,
        'owner[type]': 'people',
        'event': 'comment-created,reminder-created'
      })
          .then(response => {
            this.logLines = response.data

            this.loading = false
          })
    },

    edit(logLine) {
      this.editing = {id: logLine.subject.id, attributes: logLine.subject}

      $('#update-reminder-modal').modal('show')
    },

    resolve(logLine) {
      modal.confirm('Are you sure that you want to resolve the reminder?', ()=> {
        http.post('/api/v2/reminders/' + logLine.subject.id + '/resolve')
            .then(() => {
              notify.success('The reminder was resolved')

              this.load()
            })
      })
    },

    postpone(logLine) {
      this.editing = {id: logLine.subject.id, attributes: logLine.subject}

      $('#postpone-reminder-modal').modal('show')
    },
  }
}
</script>
